import Vue from 'vue';
import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';

import {Store} from "@/enums/Store";

import {EventInterface} from "@/types/Event";

import {Event as EventUtil} from "@/util/Event";
import {LocationInterface} from "@/types/Location";


@Module({
  namespaced: true,
})
export default class Event extends VuexModule<EventStateInterface> {
  selectedEvent?: EventInterface = undefined;
  events: EventInterface[] = [];

  @Mutation
  SET_EVENTS(events: EventUtil[]) {
    for (const event of events) {
      if (!event.locations) {
        throw new Error(`Event ${event.name} is missing locations`)
      }

      if (!event.ticketCategories) {
        throw new Error(`Event ${event.name} is missing ticket categories`)
      }
    }
    this.events = events;
  }

  @Mutation
  SET_SELECTED_EVENT(event: EventUtil) {
    this.selectedEvent = event
  }

  @Mutation
  SET_SELECTED_EVENT_LOCATIONS(locations: LocationInterface[]) {
    if (this.selectedEvent){
      this.selectedEvent.locations = locations
    }
  }

  @Action
  selectEvent(event: EventUtil) {
    const {commit, dispatch} = this.context;

    commit('SET_SELECTED_EVENT', event);
    dispatch(`${Store.LOCATION}/setSelectedLocation`, null, {root:true});
    dispatch(`${Store.APP}/incrementStep`, null, {root: true})
  }

  @Action
  filterEventLocations(locations: LocationInterface[]){
    const {commit, dispatch} = this.context;
    commit('SET_SELECTED_EVENT_LOCATIONS', locations);
  }

  get eventObjects(): EventUtil[] {
    return this.events.map((event: EventInterface) => {
      return new EventUtil(event)
    })
  }

  get selectedEventObject(): EventUtil | undefined {
    if (this.selectedEvent) {
      return new EventUtil(this.selectedEvent)
    }
    return undefined
  }
}

export interface EventStateInterface {
  selectedEvent?: EventUtil;
  events: EventUtil[];
}

export type SelectEvent = (events: EventUtil) => void
